<template lang="pug">
.cp-callai
  callai-top
  callai-team
  team-process
  team-honer
  contact-us
</template>
<script>
import callaiTop from './components/callai-top'
import callaiTeam from './components/callai-team'
import teamProcess from './components/team-process'
import teamHoner from './components/team-honer'
import contactUs from './components/contact-us'

export default {
  components: {
    callaiTop,
    callaiTeam,
    teamProcess,
    teamHoner,
    contactUs,
  },
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-callai
  background #0F1939
</style>
